import type { NotNull } from '../typescript';

export const hasValue = <T>(item: T | undefined | null): item is NotNull<T> => {
  return !!item;
};

export const hasFieldValue =
  <TKey extends string>(field: TKey) =>
  <T extends Record<string, unknown> & Record<TKey, unknown>>(
    item: T | undefined | null
  ): item is NotNull<T> => {
    return !!item && !!item[field];
  };
